module.exports = __webpack_public_path__ + "static/Stage3Back-50e23bd6374911ead9a70a36b00fd92d.png";